if (!customElements.get('tata-season-lookbook-product-modal')) {
  customElements.define(
    'tata-season-lookbook-product-modal',
    class TataSeasonLookbookProductModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('.tata-season-lookbook-product-modal__inner');
        this._scrollLockY = 0;
        this._onWheelCapture = this._handleWheelCapture.bind(this);
        this._onTouchMoveCapture = this._handleTouchMoveCapture.bind(this);
        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback?.(this.preprocessHTML.bind(this));
        });

        // 着用アイテム一覧（<template>）→「商品情報」でクイックビュー →「一覧へ戻る」
        this.listTemplate = null;
        this.headerTitle = this.querySelector('.tata-season-lookbook-product-modal__header-title');
        this.backButton = this.querySelector('[data-tata-look-back]');
        this.backButton?.addEventListener('click', () => this.renderList());
        this.modalContent?.addEventListener('click', (event) => {
          const row = event.target.closest('[data-tata-look-product]');
          if (!row || row.getAttribute('aria-disabled') === 'true') return;
          this.loadProduct(row.getAttribute('data-product-url'), row);
        });
      }

      get scrollDialog() {
        return this.querySelector('.tata-season-lookbook-product-modal__inner');
      }

      _lockPageScroll() {
        this._scrollLockY = window.scrollY || window.pageYOffset || 0;
        document.documentElement.classList.add('tata-lookbook-modal-open');
        document.body.classList.add('tata-lookbook-modal-open');
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this._scrollLockY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        window.tataLenisControl?.stop();
        document.addEventListener('wheel', this._onWheelCapture, { passive: false, capture: true });
        document.addEventListener('touchmove', this._onTouchMoveCapture, { passive: false, capture: true });
      }

      _unlockPageScroll() {
        document.removeEventListener('wheel', this._onWheelCapture, { capture: true });
        document.removeEventListener('touchmove', this._onTouchMoveCapture, { capture: true });
        document.documentElement.classList.remove('tata-lookbook-modal-open');
        document.body.classList.remove('tata-lookbook-modal-open');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, this._scrollLockY);
        window.tataLenisControl?.start();
      }

      _handleWheelCapture(event) {
        if (!this.hasAttribute('open')) return;

        const dialog = this.scrollDialog;
        if (!dialog) {
          event.preventDefault();
          return;
        }

        if (dialog.contains(event.target)) {
          event.preventDefault();
          dialog.scrollTop += event.deltaY;
          return;
        }

        event.preventDefault();
      }

      _handleTouchMoveCapture(event) {
        if (!this.hasAttribute('open')) return;

        const dialog = this.scrollDialog;
        if (dialog && dialog.contains(event.target)) return;

        event.preventDefault();
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        if (this.modalContent) this.modalContent.innerHTML = '';
        this.listTemplate = null;
        if (preventFocus) this.openedBy = null;
        this._unlockPageScroll();
        super.hide();
      }

      show(opener) {
        const templateId = opener.getAttribute('data-look-template');
        if (templateId) {
          this.listTemplate = document.getElementById(templateId);
          if (!this.listTemplate || !this.modalContent) return;
          this.renderList();
          this.openModal(opener);
          return;
        }

        this.listTemplate = null;
        this.loadProduct(opener.getAttribute('data-product-url'), opener, () => this.openModal(opener));
      }

      openModal(opener) {
        if (this.hasAttribute('open')) return;
        super.show(opener);
        this._lockPageScroll();
      }

      setView(view) {
        const fromList = view === 'product' && this.listTemplate;
        if (this.backButton) this.backButton.hidden = !fromList;
        if (this.headerTitle) {
          this.headerTitle.hidden = Boolean(fromList);
          const title = this.headerTitle.dataset[view === 'list' ? 'titleList' : 'titleProduct'];
          if (title) this.headerTitle.textContent = title;
        }
        this.classList.toggle('tata-season-lookbook-product-modal--list', view === 'list');
        if (this.scrollDialog) this.scrollDialog.scrollTop = 0;
      }

      renderList() {
        if (!this.listTemplate || !this.modalContent) return;
        this.modalContent.replaceChildren(this.listTemplate.content.cloneNode(true));
        this.setView('list');
        this.modalContent.querySelector('[data-tata-look-product]')?.focus({ preventScroll: true });
      }

      loadProduct(productUrl, trigger, onLoaded) {
        if (!productUrl || !this.modalContent) return;

        trigger.setAttribute('aria-disabled', 'true');
        trigger.classList.add('loading');
        const spinner = trigger.querySelector('.loading__spinner');
        spinner?.classList.remove('hidden');

        const fetchUrl = `${productUrl}${productUrl.includes('?') ? '&' : '?'}view=tata-lookbook-modal`;

        fetch(fetchUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info.tata-lookbook-quick-view');
            if (!productElement) {
              throw new Error('Lookbook quick view markup not found');
            }
            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            if (typeof window.tataBindLookbookThumbnailDragScroll === 'function') {
              window.tataBindLookbookThumbnailDragScroll(this.modalContent);
            }
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            this.setView('product');
            onLoaded?.();
            (this.backButton && !this.backButton.hidden ? this.backButton : null)?.focus({ preventScroll: true });
          })
          .catch(() => {
            window.location.href = productUrl;
          })
          .finally(() => {
            trigger.removeAttribute('aria-disabled');
            trigger.classList.remove('loading');
            spinner?.classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient') {
            this.classList.add(classApplied);
          }
        });
        this.preventDuplicatedIDs(productElement);
        productElement.setAttribute('data-update-url', 'false');
        productElement.querySelector('product-modal')?.remove();
        productElement.querySelectorAll('modal-dialog').forEach((node) => node.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        if (!sectionId) return;
        const oldId = sectionId;
        const newId = `lookbook-qv-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replaceAll(oldId, newId));
          }
        });
        productElement.dataset.originalSection = sectionId;
        productElement.dataset.section = newId;
      }
    }
  );
}
